import { render, staticRenderFns } from "./OwnerTextTemplate.vue?vue&type=template&id=68351ac4"
import script from "./OwnerTextTemplate.vue?vue&type=script&lang=js"
export * from "./OwnerTextTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports